import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

import styles from "./ConfigVariableList.module.css";

export type EnvironmentRelease = {
  readonly pk?: number;
  service: number;
  service_name: string;
  environment: number;
  environment_name: string;
  user: number;
  user_username: string;
  tag: string;
  date: string;
};

export default function EnvironmentConfigVariableList(props: {
  releases: EnvironmentRelease[];
}) {
  return (
    <>
      <TableContainer component={Paper} variant="outlined">
        <Table className={styles.variablesTable}>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Service</TableCell>
              <TableCell>Version (tag)</TableCell>
              <TableCell>Rollback command</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...props.releases].map((release) => (
              <ReleaseRow release={release} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

function ReleaseRow(props: { release: EnvironmentRelease }) {
  const release = props.release;
  return (
    <TableRow>
      <TableCell>{release.date}</TableCell>
      <TableCell>{release.user_username}</TableCell>
      <TableCell>{release.service_name}</TableCell>
      <TableCell>{release.tag}</TableCell>
      <TableCell>
        dg env release {release.environment_name} --service{" "}
        {release.service_name} --tag {release.tag}
      </TableCell>
    </TableRow>
  );
}
